import qs from "querystring";

const origin = 'https://apiv1.nb-s.cn';

export function post(url, params) {
  return fetch(origin + url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: qs.encode(params)
  }).then(res => res.json()).then(res => res.data);
}